// extracted by mini-css-extract-plugin
module.exports = {"container":"Events_healthgenom_container__3eb_g","item":"Events_healthgenom_item__3mH5E","workoutContainer":"Events_healthgenom_workoutContainer__1ZllW"};